<template lang="pug">
  table.table
    thead
      tr.table__row.table__row--head
        th.table__cell {{ 'history.type' | translate }}
        th.table__cell {{ 'history.name' | translate }}
        th.table__cell {{ 'history.max_weight' | translate }}
        th.table__cell {{ 'history.user' | translate }}
        th.table__cell {{ 'history.date_time' | translate }}
    v-table-body(
      :cols="5"
      :loading="!loaded"
      :empty="!mixers.length"
      :no-permissions="!allowView")
      tr.table__row(
        v-for="(item, index) in formattedMixers"
        :key="index")
        td.table__cell
          action-type {{ item.history_type }}
        td.table__cell {{ item.name | shortstr }}
        td.table__cell {{ item.max_weight }}
        td.table__cell {{ item.history_user || '--' }}
        td.table__cell {{ item.formattedDate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDateUnified } from '@/util'
import ActionType from '@/components/common/action-type/ActionType'

export default {
  name: 'HistoryMixers',

  components: {
    ActionType
  },

  mounted () {
    if (this.allowView) {
      this.loadData()
    } else {
      this.loaded = true
    }
  },

  data: () => ({
    page: 1,
    loaded: false
  }),

  methods: {
    ...mapActions('history', [
      'loadMixers'
    ]),

    async loadData () {
      this.loaded = false
      const filters = {
        farm: this.$route.params.farm_id,
        page: this.page > 1 ? this.page : null
      }
      await this.loadMixers(filters)
      this.loaded = true
    },

    loadPage (page) {
      this.page = page
      this.loadData()
    }
  },

  computed: {
    ...mapGetters('history', [
      'mixers'
    ]),

    allowView () {
      return this.hasPermission('history', 'view')
    },
    formattedMixers () {
      return this.mixers.map(item => ({
        ...item,
        formattedDate: formatDateUnified(item.history_date, true)
      }))
    }
  }
}
</script>
